import React from 'react';
import { Col } from 'react-bootstrap';

import TinySliderWrapper from 'src/shared/components/TinySliderWrapper/TinySliderWrapper';

import carouselImages from './technologyCarouselImagesConfig';
import styles from './TechnologiesCarousel.module.scss';

/* istanbul ignore next */
// TODO: fix the problem with the Carousel component because it throws an exception when rendering with data from the tests, for this reason this component is ignored from the coverage report
const TechnologiesCarousel = () => {
	if (!carouselImages.length) return null;

	return (
		<Col lg={12}>
			<TinySliderWrapper
				data-testid={'tecnologies-carousel'}
				nav={true}
				navPosition={'bottom'}
				controls={false}
				mouseDrag
				items={6}
				loop={true}
				speed={500}
				autoplay={true}
				autoplayButtonOutput={false}
				responsive={{ 0: { items: 3 }, 768: { items: 4 }, 900: { items: 6 } }}
			>
				{carouselImages.map((carouselImage, index) => (
					<div key={index} className={styles.slide}>
						<img src={carouselImage.image} style={carouselImage.style} alt={`technology ${carouselImage.name}`} />
					</div>
				))}
			</TinySliderWrapper>
		</Col>
	);
};

export default TechnologiesCarousel;
